import React, { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import { useContentMetafieldData } from '@jbhi-fi/components/src/hooks/useContentMetafieldData/useContentMetafieldData';
import { UseContentProps } from '@jbhi-fi/components/src/types';
import { CategoryLandingProps } from '../../views/CategoryLanding/CategoryLanding';
import { contentfulApiCategoryLandingPageToCategoryLandingProps } from '../../transformers/contentfulApiCategoryLandingPageToCategoryLandingProps';
import { useContentfulEntries } from '@jbhi-fi/components/src/hooks/useContentfulEntries/useContentfulEntries';
import { ContentfulCategoryLandingPage, EntryType } from '@jbhi-fi/apis/src/contentful/types';

export const CategoryLandingPropsContext = createContext<UseContentProps<CategoryLandingProps> | null>(null);

export const CategoryLandingPropsProvider = ({ children }: { children: ReactNode }) => {
  const metafieldData = useContentMetafieldData<ContentfulCategoryLandingPage>();

  const { entries, isLoading, error } = useContentfulEntries<ContentfulCategoryLandingPage>({
    filter: {
      content_type: EntryType.categoryLanding,
      'sys.id': metafieldData.sys.id,
    },
    autoRefresh: window.Jbhifi.isContentPreview,
  });

  const data = entries?.length && entries[0];
  const [categoryLandingProps, setCategoryLandingProps] = useState<CategoryLandingProps>(
    contentfulApiCategoryLandingPageToCategoryLandingProps(metafieldData)
  );

  useEffect(() => {
    setCategoryLandingProps(contentfulApiCategoryLandingPageToCategoryLandingProps(data || metafieldData));
  }, [data]);

  return (
    <CategoryLandingPropsContext.Provider value={{ data: categoryLandingProps, isLoading, error }}>
      {children}
    </CategoryLandingPropsContext.Provider>
  );
};

export const useCategoryLandingProps = (): UseContentProps<CategoryLandingProps> | null => {
  const context = useContext(CategoryLandingPropsContext);
  if (context === undefined || context === null) {
    throw new Error('useCategoryLandingProps must be used within a CategoryLandingPropsProvider');
  }

  return context;
};
